@if (plan?.plansOverview) {
  <div class="plans-overview">
    <div [innerHTML]="plan?.plansOverview | safeHtml"></div>
  </div>
}
